import { render } from "./Title.vue?vue&type=template&id=3dd9895b&scoped=true"
const script = {}

import "./Title.vue?vue&type=style&index=0&id=3dd9895b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd9895b"]])

export default __exports__